  <!-- section begin -->
  <section
    id="subheader"
    class="text-light"
    data-bgimage="url(assets/images/background/10.jpg)"
    data-stellar-background-ratio=".2"
    style="background: url(assets/images/background/16.jpg) 0% 0px / cover; "
  >
    <div class="overlay-bg t50">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1>Register Form</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- section close -->
  <section id="section-side" class="side-bg no-padding" data-bgcolor="#f9f9f9">
    <div class="container">

      <div class="card-body">
        <form [formGroup]="fileUploadForm" (ngSubmit)="onFormSubmit()">


              <h3>Personal Details</h3>

              <div class="form-row">

                  <input type="hidden" class="form-control" [(ngModel)]="valRefId" formControlName="uploadRefId" [disabled]="true" >

                <div class="form-group col-4">
                    <label>Name (In BLOCK letters) *</label>
                    <input type="text" formControlName="name" [(ngModel)]="valName" (keypress)="omit_text($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.name.errors }" maxlength="50" />
                    <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                        <div *ngIf="f.name.errors.required">Your Name is required</div>
                    </div>
                </div>
                <div class="form-group col-4">
                  <label>Gender</label>
                  <select formControlName="gender" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.gender.errors }">
                      <option value="" disabled>Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="transgender">Transgender</option>
                  </select>
                  <div *ngIf="submitted && f.gender.errors" class="invalid-feedback">
                      <div *ngIf="f.gender.errors.required">Gender is required</div>
                  </div>
              </div>
                <div class="form-group col-4">
                    <label>DOB</label>
                    <input
                    theme="dp-material"
                    class="form-control"
                    formControlName="dob"
                    [dpDayPicker]="datePickerConfig"
                    [ngClass]="{ 'is-invalid': submitted && f.dob.errors }"
                    placeholder="Date Of Birth"
                    maxlength="10"
                  />
                    <!-- <input type="text" formControlName="dob" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dob.errors }" /> -->
                    <div *ngIf="submitted && f.dob.errors" class="invalid-feedback">
                        <div *ngIf="f.dob.errors.required">DOB is required</div>
                    </div>
                </div>
            </div>
            <div class="form-row">

              <div class="form-group col-4">
                  <label>Father's Name * </label>
                  <input type="text" formControlName="fathername" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.fathername.errors }" (keypress)="omit_text($event)" maxlength="50" />
                  <div *ngIf="submitted && f.fathername.errors" class="invalid-feedback">
                      <div *ngIf="f.fathername.errors.required">Father Name is required</div>
                  </div>
              </div>
              <div class="form-group col-4">
                <label>Mobile Number *</label>
                <input type="text" formControlName="mobilenumber" [(ngModel)]="valMobile" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.mobilenumber.errors }" (keypress)="omit_number($event)" maxlength="10"/>
                <div *ngIf="submitted && f.mobilenumber.errors" class="invalid-feedback">
                    <div *ngIf="f.mobilenumber.errors.required">Mobile Number is required</div>
                </div>
                <div *ngIf="submitted && f.mobilenumber.errors" class="invalid-feedback">
                  <div *ngIf="f.mobilenumber.errors.pattern">Enter only number</div>
              </div>
               </div>

              <div class="form-group col-4">
                <label>Email Address *</label>
                <input type="text" formControlName="email" class="form-control" [(ngModel)]="valEmail" (keypress)="omit_email($event)" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" maxlength="30"  />
                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                    <div *ngIf="f.email.errors.required">Email is required</div>
                </div>
                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                  <div *ngIf="f.email.errors.pattern">Valid Email Address</div>
              </div>
              </div>
            </div>
            <div class="form-row">

              <div class="form-group col-4">
                  <label>Selected Marital Status * </label>
                  <select formControlName="maritalstatus" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.maritalstatus.errors }">
                    <option value="" disabled>Select Status</option>
                    <option value="married">Married</option>
                    <option value="widowed">Widowed</option>
                    <option value="separated">Separated</option>
                    <option value="divorced">Divorced</option>
                    <option value="single">Single</option>
                </select>
                <div *ngIf="submitted && f.maritalstatus.errors" class="invalid-feedback">
                    <div *ngIf="f.maritalstatus.errors.required">Marital status is required</div>
                </div>
              </div>

              <div class="form-group col-4">
                <label>Category *</label>
                <select formControlName="category" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.category.errors }">
                    <option value="" disabled>Select Category</option>
                    <option value="general">GENERAL</option>
                    <option value="obc">OBC</option>
                    <option value="sc">SC</option>
                    <option value="st">ST</option>
                    <option value="ews">EWS</option>
                </select>
                <div *ngIf="submitted && f.category.errors" class="invalid-feedback">
                    <div *ngIf="f.category.errors.required">Category is required</div>
                </div>
               </div>

              <div class="form-group col-4">
                <label>DIVYANG *</label>
                <select formControlName="divyang" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.divyang.errors }">
                  <option value="" disabled>Select DIVYANG</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
              </select>
              <div *ngIf="submitted && f.divyang.errors" class="invalid-feedback">
                  <div *ngIf="f.divyang.errors.required">DIVYANG is required</div>
              </div>
              </div>

              <div class="form-group col-4">
                <label>Nationality *</label>
                <input type="text" formControlName="nationality" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.nationality.errors }" />
                <div *ngIf="submitted && f.nationality.errors" class="invalid-feedback">
                    <div *ngIf="f.nationality.errors.required">Nationality is required</div>
                </div>

              </div>

            </div>

            <hr>

            <h3>Permanent Address</h3>
            <div class="form-row">

              <div class="form-group col-4">
                  <label>Door Number * </label>
                  <input type="text" formControlName="doorno" class="form-control" (keypress)="omit_spl($event)" [ngClass]="{ 'is-invalid': submitted && f.doorno.errors }" maxlength="50"/>
                  <div *ngIf="submitted && f.doorno.errors" class="invalid-feedback">
                      <div *ngIf="f.doorno.errors.required">Door Number is required</div>
                  </div>
              </div>
              <div class="form-group col-4">
                <label>Street Name *</label>
                <input type="text" formControlName="streetname" class="form-control"  (keypress)="omit_addres($event)"  [ngClass]="{ 'is-invalid': submitted && f.streetname.errors }" maxlength="100" />
                  <div *ngIf="submitted && f.streetname.errors" class="invalid-feedback">
                      <div *ngIf="f.streetname.errors.required">Street Name is required</div>
                  </div>
               </div>

              <div class="form-group col-4">
                <label>Area *</label>
                <input type="text" formControlName="area" class="form-control" (keypress)="omit_addres($event)"  [ngClass]="{ 'is-invalid': submitted && f.area.errors }" maxlength="100" />
                <div *ngIf="submitted && f.area.errors" class="invalid-feedback">
                    <div *ngIf="f.area.errors.required">Area is required</div>
                </div>
              </div>
            </div>

            <div class="form-row">

              <div class="form-group col-4">
                  <label> Village / Town / City * </label>
                  <input type="text" formControlName="vtc" class="form-control" (keypress)="omit_addres($event)"  [ngClass]="{ 'is-invalid': submitted && f.vtc.errors }" maxlength="100" />
                  <div *ngIf="submitted && f.vtc.errors" class="invalid-feedback">
                      <div *ngIf="f.vtc.errors.required">Village / Town / City is required</div>
                  </div>
              </div>
              <div class="form-group col-4">
                <label>Pincode *</label>
                <input type="text" formControlName="pincode" class="form-control" (keypress)="omit_addres($event)"  [ngClass]="{ 'is-invalid': submitted && f.pincode.errors }" maxlength="6" />
                  <div *ngIf="submitted && f.pincode.errors" class="invalid-feedback">
                      <div *ngIf="f.pincode.errors.required">Pincode is required</div>
                  </div>
               </div>

              <div class="form-group col-4">
                <label>State *</label>
                <select
            formControlName="state"
            class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f.state.errors }"
            (change)="onChangeState($event)"
          >
            <option [selected]="true" value="" [disabled]="true">Select State</option>
            <option
              *ngFor="let country of state"
              [value]="country.state_name"
            >
              {{ country.state_name }}
            </option>
          </select>

              <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                  <div *ngIf="f.state.errors.required">State is required</div>
              </div>
              </div>
            </div>

            <div class="form-row">

              <div class="form-group col-4">
                <label>District *</label>
                <select
            formControlName="district"
            class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f.district.errors }"
            (change)="onChangeDist($event)"
          >
          <option [selected]="true" value="" [disabled]="true">Select District</option>
            <option
              *ngFor="let country of district"
              [value]="country.district_name"
            >
              {{ country.district_name }}
            </option>
          </select>
              <div *ngIf="submitted && f.district.errors" class="invalid-feedback">
                  <div *ngIf="f.district.errors.required">District is required</div>
              </div>
              </div>

              <div class="form-group col-4" *ngIf="bool_crntAddress">
                <label>Same Addres</label>
                <select
            class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f.district.errors }"
            (change)="onChangeAddress($event)"
          >
          <option [selected]="true" value="" [disabled]="true">Select District</option>
            <option value="yes"> Yes </option>
            <option value="no"> No </option>
          </select>
              <div *ngIf="submitted && f.district.errors" class="invalid-feedback">
                  <div *ngIf="f.district.errors.required">District is required</div>
              </div>
              </div>
            </div>


            <hr>

            <h3>Communication Address</h3>

            <div class="form-row">

              <div class="form-group col-4">
                  <label>Door Number * </label>
                  <input type="text" formControlName="c_doorno" [(ngModel)]="dup_doorno" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.c_doorno.errors }" maxlength="10" />
                  <div *ngIf="submitted && f.c_doorno.errors" class="invalid-feedback">
                      <div *ngIf="f.c_doorno.errors.required">Door Number is required</div>
                  </div>
              </div>
              <div class="form-group col-4">
                <label>Street Name *</label>
                <input type="text" formControlName="c_streetname" [(ngModel)]="dup_street" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.c_streetname.errors }" />
                  <div *ngIf="submitted && f.c_streetname.errors" class="invalid-feedback">
                      <div *ngIf="f.c_streetname.errors.required">Street Name is required</div>
                  </div>
               </div>

              <div class="form-group col-4">
                <label>Area *</label>
                <input type="text" formControlName="c_area" [(ngModel)]="dup_area" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.c_area.errors }" maxlength="50" />
                <div *ngIf="submitted && f.c_area.errors" class="invalid-feedback">
                    <div *ngIf="f.c_area.errors.required">Area is required</div>
                </div>
              </div>
            </div>

            <div class="form-row">

              <div class="form-group col-4">
                  <label> Village / Town / City * </label>
                  <input type="text" formControlName="c_vtc" [(ngModel)]="dup_vtc" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.vtc.errors }" maxlength="50" />
                  <div *ngIf="submitted && f.vtc.errors" class="invalid-feedback">
                      <div *ngIf="f.vtc.errors.required">Village / Town / City is required</div>
                  </div>
              </div>
              <div class="form-group col-4">
                <label>Pincode *</label>
                <input type="text" formControlName="c_pincode" [(ngModel)]="dup_pincode" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.c_pincode.errors }" maxlength="6" />
                  <div *ngIf="submitted && f.c_pincode.errors" class="invalid-feedback">
                      <div *ngIf="f.c_pincode.errors.required">Pincode is required</div>
                  </div>
               </div>

              <div class="form-group col-4">
                <label>State *</label>
                <select
            formControlName="c_state"
            class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f.c_state.errors }"
            (change)="onChangeState($event)" [(ngModel)]="dup_state"
          >
            <option [selected]="true" value="" [disabled]="true">Select State</option>
            <option
              *ngFor="let country of state"
              [value]="country.state_name"
            >
              {{ country.state_name }}
            </option>
          </select>
              <div *ngIf="submitted && f.c_state.errors" class="invalid-feedback">
                  <div *ngIf="f.c_state.errors.required">State is required</div>
              </div>
              </div>
            </div>

            <div class="form-row">

              <div class="form-group col-4">
                <label>District *</label>
                <select
            formControlName="c_district"
            class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f.c_district.errors }" [(ngModel)]="dup_district"
          >
          <option [selected]="true" value="" [disabled]="true">Select District</option>
            <option
              *ngFor="let country of district"
              [value]="country.district_name"
            >
              {{ country.district_name }}
            </option>
          </select>
              <div *ngIf="submitted && f.c_district.errors" class="invalid-feedback">
                  <div *ngIf="f.c_district.errors.required">District is required</div>
              </div>
              </div>
            </div>

            <hr>


            <div class="form-row">

              <div class="form-group col-12">
                <label>Educational Qualifications</label>
                <table class="table table-bordered" formArrayName="qualification" style="text-align: center;">
                  <thead>
                    <tr>
                      <th> Examinaton</th>
                      <th>Year of Passing</th>
                      <th> Board / University</th>
                      <th>Subject</th>
                      <th>Division / marks %</th>
                      <th> <button class="btn btn-success"  type="button" (click)="addQualification()" >Add </button></th>

                    </tr>
                  </thead>
                  <tr>
                    <!-- <th colspan="2">Add Multiple Quantity:</th> -->
                    <!-- <th width="150px"></th> -->
                  </tr>
                  <tr *ngFor="let quantity of qualification().controls; let i=index" [formGroupName]="i">
                    <td>
                        <!-- Quantity : -->
                        <input type="text" formControlName="exampassed" class="form-control" (keypress)="omit_spl($event)" maxlength="50">
                        <div *ngIf="submitted && f.exampassed.errors" class="invalid-feedback">
                          <div *ngIf="f.exampassed.errors.required">Exampassed is required</div>
                      </div>
                    </td>
                    <td>
                        <!-- Price: -->
                        <input type="text" formControlName="yearpass" (keypress)="omit_number($event)" class="form-control" maxlength="4">
                    </td>
                    <td>
                      <!-- Price: -->
                      <input type="text" formControlName="university" (keypress)="omit_text($event)" class="form-control" maxlength="50">
                  </td>
                  <td>
                      <!-- Price: -->
                      <input type="text" formControlName="substudied"  (keypress)="omit_text($event)" class="form-control" maxlength="50">
                  </td>
                  <td>
                      <!-- Price: -->
                      <input type="text" formControlName="marks" class="form-control"  (keypress)="omit_decimal($event)" class="form-control" maxlength="4">
                  </td>
                    <td>
                        <button *ngIf="i >= 0" (click)="removeQualification(i)" class="btn btn-danger">Remove</button>

                    </td>
                  </tr>
                </table>

              </div>
            </div>

            <hr>


            <div class="form-row">

              <div class="form-group col-12">
                <label>Professional / Technical Qualifications</label>
                <table class="table table-bordered" formArrayName="professional" style="text-align: center;">
                  <thead>
                    <tr>
                      <th> Examinaton</th>
                      <th>Year of Passing</th>
                      <th>Details of Course</th>
                      <th> Board / University</th>
                      <th>Subject / Specialization</th>
                      <th>Mark / CGPA</th>
                      <th> <button class="btn btn-success" type="button" (click)="addprofessional()" >Add </button></th>

                    </tr>
                  </thead>
                  <tr>
                    <!-- <th colspan="2">Add Multiple Quantity:</th> -->
                    <!-- <th width="150px"></th> -->
                  </tr>
                  <tr *ngFor="let quantity of professional().controls; let j=index" [formGroupName]="j">
                    <td>
                        <!-- Quantity : -->
                        <input type="text" formControlName="exampassed" class="form-control" (keypress)="omit_text_number($event)" maxlength="50">
                    </td>
                    <td>
                        <!-- Price: -->
                        <select formControlName="yearpass" class="form-control" >
                          <option [selected]="true" value="" [disabled]="true">Select Year</option>
                          <option *ngFor="let i of arr_year" [value]="i"  >
                            {{ i }}
                          </option>
                        </select>

                        <!-- <input type="text" formControlName="yearpass" class="form-control" (change)="year_short($event)" (keypress)="omit_text_number($event)" maxlength="4"> -->
                    </td>
                    <td>
                      <!-- Price: -->
                      <input type="text" formControlName="course" class="form-control" (keypress)="omit_text_number($event)" maxlength="50">
                  </td>
                    <td>
                      <!-- Price: -->
                      <input type="text" formControlName="university" class="form-control" (keypress)="omit_text_number($event)" maxlength="50">
                  </td>
                  <td>
                      <!-- Price: -->
                      <input type="text" formControlName="substudied" class="form-control" (keypress)="omit_text_number($event)" maxlength="50" >
                  </td>
                  <td>
                      <!-- Price: -->
                      <input type="text" formControlName="marks" class="form-control" (keypress)="omit_decimal($event)" maxlength="4">
                  </td>
                    <td>
                        <button *ngIf="j >= 0" (click)="removeprofessional(j)" class="btn btn-danger">Remove</button>

                    </td>
                  </tr>
                </table>

              </div>
            </div>
            <hr>
            <div class="form-row">

              <div class="form-group col-12">
                <label>A Breif Writeup of Past experience *</label>
                <textarea maxlength="999" formControlName="pastexperience" placeholder="maximum 1000 words" class="form-control" style="resize: none;">

                </textarea>
                <!-- <input type="text" formControlName="c_pincode" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.c_pincode.errors }" />
                  <div *ngIf="submitted && f.c_pincode.errors" class="invalid-feedback">
                      <div *ngIf="f.c_pincode.errors.required">Pincode is required</div>
                  </div> -->
              </div>
            </div>
            <hr>

            <div class="form-row">

              <div class="form-group col-12">
                <label>Work Experience in chronological order</label>
                <table class="table table-bordered" formArrayName="workexp" style="text-align: center;">
                  <thead>

                    <tr>
                      <th> Name & Address of Employer</th>
                      <th > Period of Service From </th>
                      <th> Period of Service To </th>
                      <th> Designation of post & scale of Pay</th>
                      <th> Total length of Service</th>
                      <th>Nature of work & level of responsiblites</th>

                      <th> <button class="btn btn-success" type="button" (click)="addworkexp()" >Add </button></th>

                    </tr>
                  </thead>
                  <tr>
                    <!-- <th colspan="2">Add Multiple Quantity:</th> -->
                    <!-- <th width="150px"></th> -->
                  </tr>
                  <tr *ngFor="let quantity of workexp().controls; let k=index" [formGroupName]="k">
                    <td>
                        <!-- Quantity : -->
                        <input type="text" formControlName="addressofemp" class="form-control"  (keypress)="omit_text_number($event)" maxlength="50">
                    </td>
                    <td>
                        <!-- Price: -->
                        <!-- <input type="text" formControlName="from" class="form-control" (keypress)="omit_number($event)" maxlength="4"> -->
                        <input theme="dp-material" class="form-control" formControlName="from" [dpDayPicker]="datePickerConfig" [ngClass]="{ 'is-invalid': submitted && f.dob.errors }" maxlength="10" />
                    </td>
                    <td>
                      <!-- Price: -->
                      <input theme="dp-material" class="form-control" formControlName="to" [dpDayPicker]="datePickerConfig" [ngClass]="{ 'is-invalid': submitted && f.dob.errors }" maxlength="10" />
                      <!-- <input type="text" formControlName="to" class="form-control"  (keypress)="omit_number($event)" maxlength="4"> -->
                  </td>
                    <td>
                      <!-- Price: -->
                      <input type="text" formControlName="scaleofpay" class="form-control"  (keypress)="omit_number($event)" maxlength="8">
                  </td>
                  <td>
                      <!-- Price: -->
                      <input type="text" formControlName="service" class="form-control"  (keypress)="omit_text_number($event)" maxlength="8">
                  </td>
                  <td>
                      <!-- Price: -->
                      <input type="text" formControlName="naturework" class="form-control"  (keypress)="omit_text_number($event)" maxlength="50">
                  </td>
                    <td>
                        <button *ngIf="k >= 0" (click)="removeworkexp(k)" class="btn btn-danger">Remove</button>

                    </td>
                  </tr>
                </table>

              </div>
            </div>
            <hr>
            <div class="form-row">

              <div class="form-group col-4">
                <label>Organization type *</label>
                <select formControlName="presently" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.presently.errors }">
                  <option disabled value=""></option>
                  <option value="govt">Govt</option>
                  <option value="psu">PSU</option>
                  <option value="autonomus">Autonomous Institutions</option>
                  <option value="private">Private</option>
              </select>
                  <div *ngIf="submitted && f.presently.errors" class="invalid-feedback">
                      <div *ngIf="f.presently.errors.required">Presently job is required</div>
                  </div>
              </div>
              <div class="form-group col-4">
                <label>Job type *</label>
                <select formControlName="present" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.present.errors }">
                  <option disabled value=""></option>
                  <option value="Permanent">Permanent</option>
                  <option value="temporory">Temporory</option>
                  <option value="adhoc">Ad-Hoc</option>
              </select>
                  <div *ngIf="submitted && f.present.errors" class="invalid-feedback">
                      <div *ngIf="f.present.errors.required">present job is required</div>
                  </div>
              </div>
              <div class="form-group col-12">
                <label>Any other Relevent Information </label>

                <input type="text" formControlName="relevent" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.relevent.errors }" />
                  <div *ngIf="submitted && f.relevent.errors" class="invalid-feedback">
                      <div *ngIf="f.relevent.errors.required">Relevent Information is required</div>
                  </div>
              </div>
            </div>
            <hr>
            <div class="form-row">

              <div class="form-group col-4">
                <label> Post Applying For SANKALP *</label>
                <select formControlName="applypost" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.applypost.errors }">
                  <option value=""></option>
                  <option value="sankalp">Senior Consultant</option>
                  <option value="sankalp">Consultant IIS</option>
                  <option value="sankalp">Consultant </option>
                  <option value="sankalp">Associate  </option>
              </select>
                  <div *ngIf="submitted && f.applypost.errors" class="invalid-feedback">
                      <div *ngIf="f.applypost.errors.required">Apply Post is required</div>
                  </div>
              </div>
            </div>
            <hr>

            <div class="form-row">

              <div class="form-group col-4">
                <label>Upload Recent Photo *</label>
                <input type="file" id="customFile" class="form-control" name="uploadedImage"
                (change)="onFileSelect($event)" accept="image/x-png,image/jpeg" data-max-size="111" #UploadFileInput>
                <img [src]="fileArraData" class="img-fluid" alt="" srcset="" style="width: 60px; bottom: 40px; position: absolute; right: 10px;">
                <!-- <input type="file" formControlName="image" id="customFile" name="uploadedImage" #UploadFileInput> -->
                <!-- <input type="file" formControlName="image" (change)="handleFileInput($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.image.errors }" /> -->
                <div *ngIf="submitted && f.image.errors" class="invalid-feedback">
                    <div *ngIf="f.image.errors.required">Last Name is required</div>
                </div>
              </div>

              <div class="form-group col-4">
                <label>Upload Certificate *</label>
                <input type="file" id="customFile" class="form-control" name="uploadedPdf"
                (change)="onFileSelectCer($event)" accept="application/pdf" #uploadFileCerInput>
                <div *ngIf="submitted && f.certificate.errors" class="invalid-feedback">
                    <div *ngIf="f.certificate.errors.required">Certificate required</div>
                </div>
              </div>

              <div class="form-group col-4">
                <label>Upload Resume *</label>
                <input type="file" id="customFile" class="form-control" name="uploadedCer"
                (change)="onFileSelectRes($event)" accept="application/pdf" #uploadFileResInput>
                <label for="customFile">{{fileInputLabel || 'Choose File'}}</label>

                <!-- <input type="file" formControlName="resume" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.resume.errors }" /> -->
                <div *ngIf="submitted && f.resume.errors" class="invalid-feedback">
                    <div *ngIf="f.resume.errors.required">Resume is required</div>
                </div>
              </div>
            </div>


          <button class="btn btn-primary" type="submit">Save and Continue</button>

        </form>
    </div>
    <hr>

  <h2>Dashboard</h2>

  <div>
    <ul>
      <li>REF No: {{this.rollno}}</li>
      <li>Text1: {{this.text1}}</li>
      <li>Text2: {{this.text2}}</li>
      <li>Image: <img src="http://localhost:5001/{{this.uplImg}}"> </li>

    </ul>
  </div>
</div>
  </section>


  <button class="btn btn-primary" (click)="logout()">Log Out</button>
